export const convertToSentenceCasing = (text) => {
    const textLowerCase = text.toLowerCase();

    return textLowerCase.charAt(0).toUpperCase() + textLowerCase.substring(1);
};

